// extracted by mini-css-extract-plugin
export var container = "AddArea-module--container--bJkuH";
export var btn = "AddArea-module--btn--GbPDK";
export var btn__parking = "AddArea-module--btn__parking--2qcfc";
export var btn__charging = "AddArea-module--btn__charging--TJ0z3";
export var btn__society = "AddArea-module--btn__society--2U9lM";